import { render, staticRenderFns } from "./Commerce.vue?vue&type=template&id=28eeb29d&"
import script from "./Commerce.vue?vue&type=script&lang=js&"
export * from "./Commerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports